import React from 'react'

import { useNavigate } from 'react-router'

import { CardDashboard, Section } from '../../../../..'
import { URLNavigation } from '../../../../../../types'
import { ContentRoutineSection } from '../../../../../Cards/CardDashboard/styles'

const routeData = [
  {
    tag: 'Material de trabajo',
    description:
      'Accede a tu material de trabaja y continúa con tu entrenamiento',
  },
  {
    tag: 'Chat con profesores',
    description: 'Habla con tus profesores',
  },
  {
    tag: 'Nos interesa tu opinión',
    description: 'Ayúdanos a mejorar la academia-ah!',
  },
]

const StudentRouteSection = () => {
  const navigate = useNavigate()

  const handleNavegation = (section: number) => {
    const url =
      section === 0
        ? URLNavigation.ROUTE
        : section === 1
          ? URLNavigation.CHAT
          : URLNavigation.OPINION_FORM

    navigate(url)
  }
  return (
    <Section title="Ruta para formación vocal" childrenClass="route-children">
      <ContentRoutineSection>
        {routeData.map((routine, index) => {
          return (
            <CardDashboard
              key={index}
              tagText={routine.tag}
              description={routine.description}
              img={
                index === 1
                  ? '/assets/miguel-bautista-book-2.png'
                  : index === 2
                    ? '/assets/miguel-bautista-book-3.png'
                    : '/assets/miguel-bautista-img-book.png'
              }
              color="yellow"
              tagPosition="bottom"
              cardSize="sm"
              onClick={() => handleNavegation(index)}
            />
          )
        })}
      </ContentRoutineSection>
    </Section>
  )
}

export default StudentRouteSection
